/**
 * Banner Rotation Module
 * Handles auto-rotating banner images with fade transitions
 *
 * @package Advanced Regeneration
 */

/**
 * Initialize all rotating banner blocks
 */
export function initBannerRotation() {
  const banners = document.querySelectorAll('.block-banner--rotating .block-banner__wrapper[data-banner-rotation="true"]');

  banners.forEach(function(wrapper) {
    new BannerRotator(wrapper);
  });
}

/**
 * BannerRotator Class
 * Manages rotation for a single banner block
 */
class BannerRotator {
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.slides = wrapper.querySelectorAll('.block-banner__slide');
    this.currentIndex = 0;
    this.interval = parseFloat(wrapper.getAttribute('data-rotation-interval')) * 1000 || 3000;
    this.timer = null;
    this.isPaused = false;

    // Only initialize if we have multiple slides
    if (this.slides.length <= 1) {
      return;
    }

    this.init();
  }

  /**
   * Initialize rotation
   */
  init() {
    // Preload all images for smooth transitions
    this.preloadImages();

    // Start rotation
    this.startRotation();

    // Optional: Pause on hover for better UX
    this.wrapper.addEventListener('mouseenter', () => this.pause());
    this.wrapper.addEventListener('mouseleave', () => this.resume());
  }

  /**
   * Preload all banner images
   */
  preloadImages() {
    this.slides.forEach(function(slide) {
      const img = slide.querySelector('img');
      if (img && img.src) {
        const preloadImg = new Image();
        preloadImg.src = img.src;
      }
    });
  }

  /**
   * Start rotation timer
   */
  startRotation() {
    this.timer = setInterval(() => {
      if (!this.isPaused) {
        this.nextSlide();
      }
    }, this.interval);
  }

  /**
   * Stop rotation timer
   */
  stopRotation() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  /**
   * Pause rotation
   */
  pause() {
    this.isPaused = true;
  }

  /**
   * Resume rotation
   */
  resume() {
    this.isPaused = false;
  }

  /**
   * Show next slide
   */
  nextSlide() {
    // Remove active class from current slide
    this.slides[this.currentIndex].classList.remove('is-active');

    // Increment index (loop back to 0 if at end)
    this.currentIndex = (this.currentIndex + 1) % this.slides.length;

    // Add active class to new slide
    this.slides[this.currentIndex].classList.add('is-active');
  }

  /**
   * Destroy rotator (cleanup)
   */
  destroy() {
    this.stopRotation();
    this.wrapper.removeEventListener('mouseenter', () => this.pause());
    this.wrapper.removeEventListener('mouseleave', () => this.resume());
  }
}
